import { BaseScheduleDayComment } from '../../../../../@paco/entities/BaseSchedule/BaseSchedule'
import { ConceptDayComment } from '../../../../../@paco/entities/Comment/Comment'
import { getDayNumberFromDate, startOfDay } from '../../../../../@paco/helpers/date'

export const doesCommentFallOnDay = <T extends ConceptDayComment | BaseScheduleDayComment>(comment: T, day: Date): boolean => (
    'date' in comment
        ? startOfDay(comment.date).getTime() === startOfDay(day).getTime()
        : comment.dayNumber === getDayNumberFromDate(day)
)
